import { curryN, prop, propEq } from 'ramda';

import runValidations, {
  isRequired,
  isNotFuture,
  isChronologicalAfter,
  isChronologicalBefore,
  hasLengthMax,
} from '../../../../forms/validators';

const validations = {
  disabilityFrom: {
    validate: [isRequired(), isNotFuture()],
  },
  disabilityTo: {
    when: propEq('hasEnded', true),
    validate: [
      isRequired(),
      isNotFuture(),
      isChronologicalAfter(prop('disabilityFrom')),
    ],
  },
  disabilityRentalFrom: {
    when: propEq('isInvalid', true),
    validate: [
      isRequired(),
      isNotFuture(),
      isChronologicalBefore(prop('disabilityFrom')),
    ],
  },
  policeInvestigation: {
    when: propEq('investigatedByPolice', true),
    validate: [isRequired(), hasLengthMax(500)],
  },
};

export default curryN(2, (deps, values) =>
  runValidations(validations, deps, values)
);
